import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import { Badge } from '@/components/ui/badge';
import { Radio, ChevronLeft } from 'lucide-react';

export const LiveDayBanner = () => {
  const { API, user } = useContext(AuthContext);
  const [data, setData] = useState(null);

  const fetchLive = () => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    axios.get(`${API}/live-today`, token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      .then((res) => setData(res.data))
      .catch(() => {});
  };

  useEffect(() => {
    fetchLive();
    const interval = setInterval(fetchLive, 60000);
    return () => clearInterval(interval);
  }, [user]);

  if (!data?.live) return null;

  return (
    <div className="relative mt-8 overflow-hidden rounded-3xl shadow-2xl" data-testid="live-day-banner">
      <div className="absolute inset-0 bg-gradient-to-l from-red-600 via-rose-600 to-red-700"></div>
      <div className="absolute -top-20 -left-20 w-64 h-64 bg-white/10 rounded-full blur-2xl"></div>

      <div className="relative z-10 p-5 sm:p-7">
        <div className="flex items-center gap-2 mb-3">
          <span className="relative flex h-3.5 w-3.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3.5 w-3.5 bg-white"></span>
          </span>
          <span className="text-white font-black text-lg tracking-wide">LIVE — יום תחרות! 🎾</span>
        </div>

        <div className="flex flex-wrap gap-2 mb-3">
          {data.tournaments.map((t) => (
            <Link key={t.id} to={`/tournament/${t.id}`} data-testid={`live-tournament-${t.id}`}>
              <Badge className="bg-white/20 hover:bg-white/30 text-white border border-white/30 px-3 py-1.5 text-sm font-bold backdrop-blur transition-colors">
                🏆 {t.name}
                <ChevronLeft className="w-3.5 h-3.5 mr-1" />
              </Badge>
            </Link>
          ))}
        </div>

        {data.my_next_match && (
          <Link to={`/tournament/${data.my_next_match.tournament_id}`} data-testid="live-my-next-match">
            <div className="bg-white/15 backdrop-blur rounded-2xl px-4 py-3 border border-white/25 mb-3 hover:bg-white/25 transition-colors">
              <div className="text-white/80 text-xs font-bold mb-0.5">המשחק הבא שלך</div>
              <div className="text-white font-black text-lg flex items-center gap-2 flex-wrap">
                <Radio className="w-4 h-4 animate-pulse" />
                נגד {data.my_next_match.opponent_name}
                {data.my_next_match.round && <span className="text-white/80 text-sm font-bold">• {data.my_next_match.round}</span>}
              </div>
            </div>
          </Link>
        )}

        {data.recent_results?.length > 0 && (
          <div className="flex flex-col gap-1.5">
            {data.recent_results.slice(0, 3).map((r, i) => (
              <div key={i} className="text-white/90 text-sm font-semibold flex items-center gap-2" data-testid={`live-result-${i}`}>
                <span>🏆</span>
                {r}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
